import { createEntityAdapter } from '@ngrx/entity';
import { Configuration } from '../models/configuration.model';

export const configurationEntityAdapter = createEntityAdapter<Configuration>({
  selectId: (configuration) => configuration.deployment.id
});
